import { PrimaryButton } from 'ui/button';
import styled from 'styled-components';
import { useTranslation } from '../hooks/useTranslation';
import { useSubmit } from '../hooks/form';

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;
  padding: 0 ${({ theme }) => theme.spacing.values.base};
`;

export const Footer = () => {
  const { t } = useTranslation();
  const submit = useSubmit();
  return (
    <Wrapper>
      <PrimaryButton onClick={submit} data-test="dcb-submit-button">
        {t('footer.insertHandlebars')}
      </PrimaryButton>
    </Wrapper>
  );
};
